<template>
  <div>
    <Header />
  </div>
</template>
<script>
import Header from "./Header";
export default {
  name: "Main",
  components: {
    Header,
  },
  created() {
    this.$store.commit("SET_PAGE_TYPE", "alex-connect");
    this.$store.commit("SET_PAGE_FOOTER_BACKGROUND_COLOR", "#F7F7F7");
    // console.log(
    //   "Background Color",
    //   this.$store.state.pageFooterBackgroundColor
    // );
  },
};
</script>